import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { get, filter, forEach, isEmpty } from 'lodash';
import VatCTABanner from './VatCTABanner';
import Toast from 'shared-components/toast/toast';
import TaxDetailsCopy from './TaxDetailsCopy';
import GuestTaxDetailsCopy from './GuestTaxDetailsCopy';
import RemoveTaxModal from '../modals/RemoveTaxModal';
import { intlTaxTypeDetails, intlTaxTypeId,
  intlTaxTypeRates, intlAddOnsTaxType } from '../data/translationsData';
import { removeVatProfile } from '../../app-main/actions/fee-profile';
import { TaxInvoicesList } from './invoice/TaxInvoicesList';

class TaxDetails extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showSubmittedToast: false,
      showRemovedToast: false,
      showRemoveTaxModal: false,
      intlDataKey: '',
      federalFee: {},
      federalFeeName: 'other',
      subRegionFeeName: 'all_provinces',
      hasFetchedRegionalFees: false,
      vatProfiles: [],
      federalVat: {},
      subRegionVat: {},
      federalVatProfileId: '',
      subRegionVatProfileId: '',
      showRemoveBtnSpinner: false,
      showRemoveError: false,
      allInvoices: []
    };

    this.openRemoveTaxModal = this.openRemoveTaxModal.bind(this);
    this.removeTaxProfile = this.removeTaxProfile.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount () {
    const { fee_profiles, isCanadaProfile, fees } = this.props;
    const feeTypes = get(fees, 'feeTypes', []);
    const federalFee = filter(feeTypes, (feeType) => { return !feeType.is_subregion; });

    const federalFeeName = isCanadaProfile ?
      'gst_hst' : get(federalFee, '[0].name', 'other');

    const hasFetchedRegionalFees = get(fees, 'hasFetched', false);
    const vatProfiles = get(fee_profiles, 'vatAddress.data');
    let federalVat = {};
    let subRegionVat = {};

    forEach(vatProfiles, (profile) => {
      if (get(profile, 'is_subregion')) {
        subRegionVat = profile;
      } else {
        federalVat = profile;
      }
    });

    const federalVatProfileId = get(federalVat, '_id', '');
    const subRegionVatProfileId = get(subRegionVat, '_id', '');
    const stateObj = {
      federalFee,
      federalFeeName,
      hasFetchedRegionalFees,
      vatProfiles,
      federalVat,
      subRegionVat,
      federalVatProfileId,
      subRegionVatProfileId
    };
    // needs to be set to state so that the value updates which then triggers
    // componentDidUpdate logic in toast component
    if ('submitted' === this.props.subFlow && !isEmpty(federalVat)) {
      this.setState({
        showSubmittedToast: true,
        ...stateObj
      });
    } else {
      this.setState({
        ...stateObj
      });
    }
  }

  openRemoveTaxModal (isFederal) {
    const { federalFeeName, subRegionFeeName, federalVatProfileId,
      subRegionVatProfileId } = this.state;
    const dataKey = isFederal ? federalFeeName : subRegionFeeName;
    const feeProfileId = isFederal ? federalVatProfileId : subRegionVatProfileId;

    this.setState({
      intlDataKey: dataKey,
      showRemoveTaxModal: true,
      feeProfileIdToRemove: feeProfileId
    });
  }

  removeTaxProfile () {
    const { dispatch, token, profile } = this.props;
    const ssoId = get(profile, 'SSOid', '');
    this.setState({
      showRemovedToast: true,
      showSubmittedToast: false
    });

    dispatch(removeVatProfile(token, ssoId, this.state.feeProfileIdToRemove))
      .then(data => {
        if (200 === get(data, 'statusCode')) {
          this.setState({
            federalVat: {},
            showRemoveBtnSpinner: false,
            showRemoveTaxModal: false
          });
        }
      })
      .catch(err => {
        this.setState({
          showRemoveBtnSpinner: false,
          showRemoveError: true
        });
        return null;
      });
  }

  closeModal (whichModal) {
    if ('removeTaxDetailsModal' === whichModal) {
      this.setState({
        showRemoveTaxModal: false
      });
    }
  }

  render () {
    const {
      fees,
      isCanadaProfile,
      dispatch,
      profile,
      invoices,
      locale,
      token
    } = this.props;

    const { federalFeeName, federalVat, subRegionVat, showRemovedToast,
      showSubmittedToast, showRemoveTaxModal, intlDataKey, showRemoveBtnSpinner, showRemoveError } = this.state;

    const feeTypes = get(fees, 'feeTypes', []);
    const feeCategories = feeTypes.map(feeType => feeType.category);
    const hasVAT = feeCategories.includes('VAT');
    const vatRegions = get(fees, 'regions', []);
    const hasFederalVat = !isEmpty(federalVat);
    const hasSubRegionVat = !isEmpty(subRegionVat);
    const isHost = get(profile, 'is_host');

    const invoicesByYear = get(invoices, 'invoiceYears.data.invoice_years', []);
    const hasInvoices = !isEmpty(invoicesByYear);

    return (
      <div className="TaxDetails no-gutter">
        {
          isEmpty(vatRegions) ?
            <div>
              <FormattedMessage
                id="hosting.tax_details_page_.no_tax_info_copy"
                defaultMessage="There is no tax information at this time."/>
            </div>
            :
            <div className="ps-row-nested">
              <div className="details col-xs-12 col-md-8 no-gutter">
                <h5>
                  <FormattedMessage { ...get(intlTaxTypeDetails, federalFeeName, intlTaxTypeDetails.other) } />
                </h5>
                <hr className="margin-lg-bottom margin-lg-top" />
                <div className="margin-lg-bottom">
                  {
                    isHost
                      ? <TaxDetailsCopy classNames={'margin-xxl-bottom'} />
                      : <GuestTaxDetailsCopy classNames={'margin-xxl-bottom'} />
                  }
                </div>

                <VatCTABanner
                  icon="signage"
                  header={<FormattedMessage { ...get(intlTaxTypeDetails, federalFeeName, intlTaxTypeDetails.other) } />}
                  body={ hasFederalVat &&
                   <div>
                     <div className="text-small">
                       <FormattedMessage { ...get(intlTaxTypeId, federalFeeName, intlTaxTypeId.other) } />:
                       <span className="margin-sm-left">{get(federalVat, 'vat_id', '')}</span>
                     </div>
                     { isHost &&
                       <div className="text-small">
                         <FormattedMessage { ...get(intlTaxTypeRates, federalFeeName, intlTaxTypeRates.other) } />:
                         <span className="margin-sm-left">{parseFloat((get(federalVat, 'vat_percent', '') * 100).toFixed(2))}%</span>
                       </div>
                     }
                   </div>}
                  buttonText={ hasFederalVat ?
                    <FormattedMessage
                      id="hosting.tax_details_page_.update_button_text"
                      defaultMessage="Update" />
                    :
                    <FormattedMessage
                      id="hosting.tax_details_page_.add_button_text"
                      defaultMessage="Add" />
                  }
                  primaryBtn={!hasFederalVat}
                  alertState={false}
                  onClickAction={() => {
                    hasFederalVat ?
                      location.href = '/account/tax-details/edit'
                      :
                      location.href = '/account/tax-details';
                  }
                  }
                  secondaryBtnText={ hasFederalVat &&
                   <img src="/web-hosting/assets/images/trash.svg?v=rb" alt="delete" />
                  }
                  secondaryOnClickAction={() => { this.openRemoveTaxModal(true); }}
                />
                {
                  isCanadaProfile &&
                 <VatCTABanner
                   icon="signage"
                   header={<FormattedMessage { ...intlTaxTypeDetails.all_provinces } />}
                   body={ hasSubRegionVat &&
                     <div>
                       <div className="text-small"><FormattedMessage { ...intlTaxTypeId.other } />:
                         <span className="margin-sm-left">{get(subRegionVat, 'vat_id', '')}</span>
                       </div>
                       { isHost &&
                         <div className="text-small"><FormattedMessage { ...intlTaxTypeRates.other } />:
                           <span className="margin-sm-left">{parseFloat((get(subRegionVat, 'vat_percent', '') * 100).toFixed(2))}%</span>
                         </div>
                       }
                     </div>
                   }
                   buttonText={ hasSubRegionVat ?
                     <FormattedMessage
                       id="hosting.tax_details_page_.update_button_text"
                       defaultMessage="Update" />
                     :
                     <FormattedMessage
                       id="hosting.tax_details_page_.add_button_text"
                       defaultMessage="Add" />
                   }
                   secondaryBtnText={ hasSubRegionVat &&
                     <img src="/web-hosting/assets/images/trash.svg?v=rb" alt="delete" />
                   }
                   onClickAction={() => {
                     hasSubRegionVat ?
                       location.href = '/account/tax-details/provincial/edit'
                       :
                       location.href = '/account/tax-details/provincial';
                   }}
                   secondaryOnClickAction={() => { this.openRemoveTaxModal(false); }}
                   primaryBtn={ !hasSubRegionVat }
                   alertState={false}
                 />
                }

                {
                  isHost &&
                 <div>
                   <div className="padding-lg gray-lighter-bg w-100 margin-lg-bottom">
                     <FormattedMessage {...get(intlAddOnsTaxType, federalFeeName, intlAddOnsTaxType.other) } />
                     <a className="margin-sm-left underline" href='/hosting/add-ons'>
                       <FormattedMessage
                         id="hosting.tax_details_page.here_link"
                         defaultMessage=" here."
                       />
                     </a>
                   </div>
                 </div>
                }

                <Toast
                  error={false}
                  show={showSubmittedToast}
                  text={
                    <FormattedMessage
                      id="hosting.tax_details_page_.details_added_toast_message"
                      defaultMessage="Details added"/>}
                />

                <Toast
                  error={false}
                  show={showRemovedToast}
                  text={<FormattedMessage
                    id="hosting.tax_details_page_.details_removed_toast_message"
                    defaultMessage="Details removed"/>}
                />
              </div>
              {hasInvoices &&
              <TaxInvoicesList
                locale={locale}
                token={token}
                dispatch={dispatch}
              />
              }
            </div>
        }

        <RemoveTaxModal
          showModal={showRemoveTaxModal}
          intlDataKey={intlDataKey}
          isHost={isHost}
          removeTaxProfile={this.removeTaxProfile}
          closeModal={this.closeModal}
          showRemoveBtnSpinner={showRemoveBtnSpinner}
          error={showRemoveError}
        />
      </div>
    );
  }
}

TaxDetails.propTypes = {
  fee_profiles: PropTypes.object
};

export default TaxDetails;
